// ── Athena Prompt Context ─────────────────────────────────────────────────────
// Builds a short (<500 char) cognitive directive string for the LLM.
// Supplements the main system prompt — does NOT replace it.
// Includes user-confirmed preference overrides.

import { buildResponseProfile } from './athenaResponseProfile';
import { getPreferenceOverrides } from './athenaPreferenceLearning';

const OVERRIDE_DIRECTIVES = {
  IMAGE_REQUEST:   'Inclua referências visuais e analogias visuais sempre que possível.',
  STEP_REQUEST:    'Organize suas respostas em passos numerados.',
  EXAMPLE_REQUEST: 'Inclua sempre pelo menos um exemplo prático.',
  SHORT_REQUEST:   'Mantenha respostas concisas e diretas ao ponto.',
};

export function buildCognitivePrompt(cognitiveProfile, profileId = null) {
  if (!cognitiveProfile) return '';

  const rp      = buildResponseProfile(cognitiveProfile);
  const traits   = cognitiveProfile.traits || [];
  const [primary] = traits;
  const overrides = profileId ? getPreferenceOverrides(profileId) : {};
  const parts    = [];

  // Primary trait directive
  if (primary === 'VISUAL')
    parts.push('Explique usando exemplos visuais, analogias e comparações concretas.');
  else if (primary === 'ESTRUTURADO')
    parts.push('Organize respostas em tópicos, listas ou passos numerados.');
  else if (primary === 'CONVERSACIONAL')
    parts.push('Use tom conversacional, frases curtas e conecte ideias com o contexto da conversa.');
  else if (primary === 'PRÁTICO')
    parts.push('Priorize ação e resultados. Minimize teoria. Seja direto e objetivo.');

  // Depth adjustment
  if (rp?.explanationDepth === 'shallow') parts.push('Respostas concisas e diretas.');
  if (rp?.explanationDepth === 'deep')    parts.push('Pode aprofundar com mais detalhes.');

  // Example frequency
  if (rp?.exampleFrequency === 'high') parts.push('Use exemplos práticos frequentemente.');

  // Conversation enrichment
  if (rp?.conversationLevel === 'high') parts.push('Adicione contexto e conecte ideias à conversa.');

  // User-confirmed preference overrides (accepted insights)
  for (const [sig, enabled] of Object.entries(overrides)) {
    if (enabled && OVERRIDE_DIRECTIVES[sig]) parts.push(OVERRIDE_DIRECTIVES[sig]);
  }

  return parts.join(' ').slice(0, 500);
}
